module.exports = __webpack_public_path__ + "static/d-MRomero-3388470df278de431ae302f4c7cad4e9.jpg";